const titleCaseWord = (str: string) => {
  if (!str) return str
  return str[0].toUpperCase() + str.slice(1)
}

const isSiretOrSiren = (text: string) => {
  text = text.replace(/\s/g, '')
  return (text.length === 9 || text.length === 14) && !isNaN(Number(text))
}

const getEmailInitials = (email: string) => {
  return email?.charAt(0).toUpperCase() + email?.split('.')[1]?.charAt(0).toUpperCase()
}

export { titleCaseWord, isSiretOrSiren, getEmailInitials }
